// TODO: https://github.com/bem/webpack-bem-loader/issues/32
module.exports = {
    "logo_type_link": {
        "yandex": "Яндекс"
    }
};